// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"198":"css/auth-pages","252":"css/app","460":"css/error-pages","466":"css/nova-fonts"}[chunkId] + ".css";
};